import { Sidebar, SidebarContent } from '@talentmesh/ui/components/sidebar';
import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

const NavDrawer = ({ children }: React.PropsWithChildren) => {
    return (
        <Sidebar
            variant="inset"
            collapsible="none"
            className={cn('border-sidebar-border bg-sidebar text-sidebar-foreground h-full shrink-0 border-r')}
        >
            <SidebarContent className="text-muted-foreground gap-0 py-2.5">{children}</SidebarContent>
        </Sidebar>
    );
};

export default NavDrawer;
